import React from 'react';

import shieldIcon from '../../../assets/img/shield.png';
import eyeIcon from '../../../assets/img/eye.png';
import redBell from '../../../assets/img/redBell.png';
import redZ from '../../../assets/img/redZ.png';
import yellowZ from '../../../assets/img/yellowZ.png';
import greenZ from '../../../assets/img/greenZ.png';
import yellowBell from '../../../assets/img/yellowBell.png';

function TimelineItemImg(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  ) {
    let icon;
    switch (props.item.type) {
      case 'eye':
        icon = eyeIcon;
        break;
      case 'yellowBell':
        icon = redBell;
        break;
      case 'redBell':
        icon = redBell;
        break;
      case 'shield':
        icon = shieldIcon;
        break;
      case 'redZ':
        icon = redZ;
        break;
      case 'yellowZ':
        icon = yellowZ;
        break;
      case 'greenZ':
        icon = greenZ;
        break;
      default:
        break;
    }

    if (!icon) {
      throw new Error(
        'No icon found for type in TimelineItemImg: ' + props.item.type,
      );
    } else {
      return (
        <div className={props.item.type + '-container'}>
          <img
            src={icon}
            alt={props.item.type}
            className={props.item.type}
          ></img>
        </div>
      );
    }
  } else {
    return null;
  }
}

export { TimelineItemImg };
